import { Component, OnInit } from '@angular/core';
import { MediaService } from './../../services/media.service';
import { AppConfig } from './../../config/app-config';
import { FileSection, FileType, FileData } from './../../models/fileData';
import * as $ from 'jquery';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeResourceUrl, } from '@angular/platform-browser';

@Component({
  selector: 'app-videos',
  templateUrl: './videos.component.html',
  styleUrls: ['./videos.component.css']
})
export class VideosComponent implements OnInit {

  constructor(private mediaService: MediaService, public modalService: NgbModal, private appConfig: AppConfig, public sanitizer: DomSanitizer) { }

  
  collectionSize = 0;
  AllMedia: any[] = [];
  MediaCategories$: any[] = [];
  MediaList$: any[] = [];
  FeaturedArticle$: any;
  textFilter: string = "";
  selectedCategory$: number = 0;
  VideoTitle: string = "";
  VideoUrl: string = "";
  url: SafeResourceUrl;

  ngOnInit() {
  }

  getMediaCategoriesList() {
    this.mediaService.getMediaCategoriesList().subscribe((response) => {
      this.MediaCategories$ = response as any[];
    }, (error) => {
      console.error(error);
    });
  }


  getMediaList() {
    this.mediaService.getMediaList().subscribe((response) => {

      this.AllMedia = response as any[];

      this.AllMedia.sort((a, b) => (a.ArticleDate > b.ArticleDate) ? 1 : -1)

      this.MediaList$ = this.AllMedia.filter(x => x.mediaType >= 10);
      this.collectionSize = this.MediaList$.length;
      this.getLatestNewsletter();
      $('#loading').hide();
    }, (error) => {
      console.error(error);
    });
    return null;
  }

  getLatestNewsletter() {
    this.FeaturedArticle$ = this.AllMedia.filter(x => x.mediaType >= 10).find(x => x.featuredArticle == true);
  }

  ngAfterContentInit() {
    this.getMediaCategoriesList();
    //this.getMediaLocationsList();
    this.getMediaList();
  }

  applyFilters() {

    this.MediaList$ = this.AllMedia.filter(x => x.mediaType >= 10);
    const filterText = this.textFilter.toLowerCase();
    const result = [];

    if (this.selectedCategory$ > 0) {
      //category search
      const filteredData = this.AllMedia.filter(x => x.categoryId === this.selectedCategory$);
      result.push(filteredData);
    }

    if (this.textFilter.length > 0) {
      //text search
      result.push(this.AllMedia.filter(x =>
        x.title.toLowerCase().includes(filterText) ||
        x.description.toLowerCase().includes(filterText) ||
        x.tags.toLowerCase().includes(filterText) ||
        x.author.toLowerCase().includes(filterText)
      ));
    }

    if (result.length > 0) {
      const final = [];

      //combine result into one final array
      result.forEach(function (val, ind, arr) {
        final.push(val);
      });

      //remove duplicates from final array
      const unique = final.filter(function (elem, index, self) {
        return index === self.indexOf(elem);
      });

      this.MediaList$ = unique[0];
    }

    if (this.MediaList$.length === 0) {
      this.MediaList$ = null;
      this.collectionSize = 0;
    }
    else {
      this.collectionSize = this.MediaList$.length;
    }

  }


  youTubeGetID(url) {
  var ID = '';
  url = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  if (url[2] !== undefined) {
    ID = url[2].split(/[^0-9a-z_\-]/i);
    ID = ID[0];
  }
  else {
    ID = url;
  }
  return ID;
}

  resetSearch() {
    this.selectedCategory$ = 0;
    //this.selectedLocation$ = 0;
    this.textFilter = "";
    this.MediaList$ = this.AllMedia.filter(x => x.mediaType >= 10);
    this.collectionSize = this.MediaList$.length;
  }

  viewVideo(linkedId, contentModal) {
    this.mediaService.getMediaArticle(linkedId).subscribe((response) => {

      this.VideoTitle = response.title;
      this.VideoUrl = this.youTubeGetID(response.copy);
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/" + this.VideoUrl); 


      this.modalService.open(contentModal, { centered: true, size: 'lg' });

      //this.mediaService.getMediaCategoriesList().subscribe((catResponse) => {
      //  this.MediaArticle$.title = response.title;
      //  const myDate = response.articleDate as Date;
      //  this.MediaArticle$.articleDate = this.datePipe.transform(myDate, 'dd MMM yyyy');//myDate.getDay() + ' ' + this.monthNames[myDate.getMonth()] + ' ' + myDate.getFullYear();
      //  try {
      //    //this.MediaArticle$.categoryId = response.categoryId;
      //    this.MediaArticle$.categoryId = catResponse.find(x => x.id === response.categoryId).title;
      //  } catch (e) {

      //  }

      //  this.MediaArticle$.description = response.description;
      //  this.MediaArticle$.copy = this.sanitizer.bypassSecurityTrustHtml(response.copy);
      //  this.getImages(response.id);

      //  this.getOtherMediaReleases(response.id);
      //  $('#loading').hide();

      //  //this.twUrl += escape(response.title);
      //});

    }, (error) => {
      console.log(error);
    })










   

    //setTimeout(function () {
    //  try {

    //    refreshCarousel();
    //  } catch (e) {
    //    console.log(e.message);
    //  }

    //}, 2000);
  }

}
